import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import './WelcomePage.css';

const WelcomePage = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useContext(UserContext);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [showContent, setShowContent] = useState(false);

  // Handle video load - simplified
  const handleVideoLoad = () => {
    console.log('Video loaded successfully');
    setVideoLoaded(true);
    setTimeout(() => setShowContent(true), 800);
  };

  const handleVideoError = (e) => {
    console.error('Video failed:', e);
    console.warn('Using fallback background');
    setVideoLoaded(false); // Keep fallback showing
    setShowContent(true);
  };

  // Try to play video after component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      const video = document.querySelector('.backgroundVideo');
      if (video) {
        video.play().catch(e => console.log('Autoplay failed:', e));
      }
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);

  // Determine user status for UI customization
  const getUserStatus = () => {
    if (isLoading) return 'loading';
    if (!user || user.isGuest) return 'guest';
    const hasDigitalCard = user.title || user.bio || user.cardImage;
    const isNewUser = !hasDigitalCard;
    return isNewUser ? 'new' : 'returning';
  };

  const userStatus = getUserStatus();

  return (
    <div className="welcomePage">
      {/* Sophisticated Layered Video Background */}
      <div className="videoContainer">
        {/* Dark navy base layer */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(135deg, #0a0f1c 0%, #1a1a2e 50%, #16213e 100%)',
          zIndex: 1
        }}></div>
        
{/* Background video layer (full screen, blurred) */}
<video
  muted
  loop
  playsInline
  autoPlay
  style={{
    position: 'absolute',
    top: '0%',
    left: '-1%',
    width: '100%', 
    height: '100%', 
    objectFit: 'cover',
    objectPosition: 'center center',
    opacity: 0.8,
    filter: 'blur(3px) brightness(0.8) saturate(0.9)',
    zIndex: 2
  }}
>
  <source src="/videos/welcome-animation.mp4" type="video/mp4" />
</video>
        
        {/* Main video (70% size, framed by background) */}
        <video
          className="backgroundVideo"
          muted
          loop
          playsInline
          onLoadedData={handleVideoLoad}
          onError={handleVideoError}
          style={{
            position: 'absolute',
            top: '5%',
            left: '16%',
            width: '70%', 
            height: '70%', 
            objectFit: 'cover',
            borderRadius: '16px',
            boxShadow: '0 25px 80px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.1)',
            zIndex: 3
          }}
        >
          <source src="/videos/welcome-animation.mp4" type="video/mp4" />
        </video>
        
        {/* Fallback gradient if video doesn't load */}
        {!videoLoaded && (
          <div className="fallbackBackground" style={{zIndex: 4}} />
        )}
      </div>

      {/* Content Overlay */}
      <div className={`contentOverlay ${showContent ? 'visible' : ''}`}>
        
        {/* 
<div className="brandSection">
  <h1 className="logoText">ARTIFEX</h1>
  <p className="tagline">Aesthetic Intelligence Platform</p>
</div>
*/}

        {/* User Status Indicator */}
        {userStatus !== 'loading' && (
          <div className="statusSection">
            {userStatus === 'guest' && (
              <p className="statusText">
                Welcome to Artifex • <button className="linkButton" onClick={() => navigate('/auth/login')}>Sign In</button>
              </p>
            )}
            {userStatus === 'new' && (
              <p className="statusText">
                Welcome, {user.displayName || 'User'}
              </p>
            )}
            {userStatus === 'returning' && (
              <p className="statusText">
                Welcome back, {user.displayName || 'User'}
              </p>
            )}
          </div>
        )}

      </div>

      {/* Sophisticated Glass Navigation - All 5 Links - FIXED POSITIONING */}
      <div style={{
        position: 'fixed',
        bottom: '6.2%',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 100,
        display: 'flex',
        gap: '2.2rem',
        padding: '1rem 2rem',
        background: 'rgba(255, 255, 255, 0.08)',
        backdropFilter: 'blur(20px)',
        borderRadius: '20px',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
      }}>
        <a href="/discover" style={{
          color: 'rgba(255, 255, 255, 0.95)', 
          textDecoration: 'none', 
          padding: '0.8rem 1.2rem',
          fontFamily: 'Georgia, serif',
          fontSize: '1rem',
          fontWeight: '400',
          letterSpacing: '0.08em',
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '12px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          transition: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          backdropFilter: 'blur(10px)',
          display: 'inline-block',
          whiteSpace: 'nowrap'
        }} onMouseOver={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.15)';
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.2)';
        }} onMouseOut={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.05)';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = 'none';
        }}>DISCOVER</a>
        
        <a href="/guides" style={{
          color: 'rgba(255, 255, 255, 0.95)', 
          textDecoration: 'none', 
          padding: '0.8rem 1.2rem',
          fontFamily: 'Georgia, serif',
          fontSize: '1rem',
          fontWeight: '400',
          letterSpacing: '0.08em',
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '12px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          transition: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          backdropFilter: 'blur(10px)',
          display: 'inline-block',
          whiteSpace: 'nowrap'
        }} onMouseOver={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.15)';
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.2)';
        }} onMouseOut={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.05)';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = 'none';
        }}>GUIDES</a>
        
        <a href="/editorials" style={{
          color: 'rgba(255, 255, 255, 0.95)', 
          textDecoration: 'none', 
          padding: '0.8rem 1.2rem',
          fontFamily: 'Georgia, serif',
          fontSize: '1rem',
          fontWeight: '400',
          letterSpacing: '0.08em',
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '12px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          transition: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          backdropFilter: 'blur(10px)',
          display: 'inline-block',
          whiteSpace: 'nowrap'
        }} onMouseOver={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.15)';
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.2)';
        }} onMouseOut={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.05)';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = 'none';
        }}>EDITORIALS</a>
        
        <a href="/signals" style={{
          color: 'rgba(255, 255, 255, 0.95)', 
          textDecoration: 'none', 
          padding: '0.8rem 1.2rem',
          fontFamily: 'Georgia, serif',
          fontSize: '1rem',
          fontWeight: '400',
          letterSpacing: '0.08em',
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '12px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          transition: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          backdropFilter: 'blur(10px)',
          display: 'inline-block',
          whiteSpace: 'nowrap'
        }} onMouseOver={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.15)';
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.2)';
        }} onMouseOut={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.05)';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = 'none';
        }}>SIGNALS</a>
        
        <a href="/shop" style={{
          color: 'rgba(255, 255, 255, 0.95)', 
          textDecoration: 'none', 
          padding: '0.8rem 1.2rem',
          fontFamily: 'Georgia, serif',
          fontSize: '1rem',
          fontWeight: '400',
          letterSpacing: '0.08em',
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '12px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          transition: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          backdropFilter: 'blur(10px)',
          display: 'inline-block',
          whiteSpace: 'nowrap'
        }} onMouseOver={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.15)';
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.2)';
        }} onMouseOut={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.05)';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = 'none';
        }}>SHOP</a>
      </div>

      {/* Loading State */}
      {(isLoading || !showContent) && (
        <div className="loadingOverlay">
          <div className="loadingContent">
            <div className="loadingSpinner"></div>
            <p className="loadingText">Loading Artifex...</p>
          </div>
        </div>
      )}

    </div>
  );
};

export default WelcomePage;